import { Refresh } from '@mui/icons-material';
import { Alert,Box,Button,Typography } from '@mui/material';
import axios from 'axios';
import React,{ useCallback,useEffect,useState } from 'react';

export function reloadApplication(reload:()=>void=()=>window.location.reload()){reload();}

const VersionChecker: React.FC = () => {
  // Инициализируем currentVersion сразу с правильным значением
  const [currentVersion] = useState<string>(process.env.REACT_APP_VERSION || '1.0.1');
  const [serverVersion, setServerVersion] = useState<string>('');
  const [needsUpdate, setNeedsUpdate] = useState(false);
  const [isChecking, setIsChecking] = useState(false);
  const [error, setError] = useState<string | null>(null);



  const checkServerVersion = useCallback(async () => {
    try {
      setIsChecking(true);
      setError(null);

      const response = await axios.get('/api/v1/version', {
        timeout: 5000,
        headers: {
          'Cache-Control': 'no-cache',

        }
      });

      const serverVer = response.data.version;
      setServerVersion(serverVer);

      // Сравниваем версии только если обе версии загружены
      if (currentVersion && serverVer && currentVersion !== serverVer) {
        console.log(`🔄 Версия не совпадает: клиент=${currentVersion}, сервер=${serverVer}`);
        setNeedsUpdate(true);
      } else if (currentVersion && serverVer) {
        console.log(`✅ Версии совпадают: ${currentVersion}`);
        setNeedsUpdate(false);
      }

    } catch (err: any) {
      console.warn('⚠️ Не удалось проверить версию сервера:', err.message);
      setError('Не удалось проверить версию сервера');
      // Не показываем ошибку пользователю, если сервер недоступен
    } finally {
      setIsChecking(false);
    }
  },[currentVersion]);

  useEffect(() => {
    // Проверяем версию сервера
    checkServerVersion();
  }, [checkServerVersion]);

  const handleForceReload = () => {
    console.log('🔄 Принудительная перезагрузка...');

    // Keep durable operation IDs: an update must not permit a duplicate paid intent.
    reloadApplication();
  };

  const handleRetry = () => {
    checkServerVersion();
  };

  if (needsUpdate) {
    return (
      <Box sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        p: 2,
        backgroundColor: 'background.paper',
        boxShadow: 2
      }}>
        <Alert
          severity="warning"
          action={
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Button
                size="small"
                onClick={handleRetry}
                disabled={isChecking}
              >
                Проверить
              </Button>
              <Button
                size="small"
                variant="contained"
                startIcon={<Refresh />}
                onClick={handleForceReload}
              >
                Обновить
              </Button>
            </Box>
          }
        >
          <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
            Доступна новая версия приложения!
          </Typography>
          <Typography variant="caption" sx={{ display: 'block', mt: 0.5 }}>
            Текущая версия: {currentVersion} | Новая версия: {serverVersion}
          </Typography>
        </Alert>
      </Box>
    );
  }

  if (error && process.env.NODE_ENV === 'development') {
    return (
      <Box sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        p: 1
      }}>
        <Alert
          severity="info"
          sx={{ fontSize: '0.75rem' }}
          action={
            <Button size="small" onClick={handleRetry}>
              Повторить
            </Button>
          }
        >
          Версия: {currentVersion} | Сервер: недоступен
        </Alert>
      </Box>
    );
  }

  return null;
};

export default VersionChecker;

